import api from 'api'
import { PositionId, WorkerRequirementId } from './types'

type AssignRequirementToPositionParams = {
  positionId: PositionId
  requirementId: WorkerRequirementId
  mustHave: boolean
}

export async function assignRequirementToPosition({
  positionId,
  requirementId,
  mustHave,
}: AssignRequirementToPositionParams): Promise<void> {
  await api.put(`/admin/positions/${positionId}/requirements`, {
    requirementId,
    mustHave,
  })
}
